
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"37","fill":"none","viewBox":"0 0 60 37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M57.3 37H2.5C1.1 37 0 35.9 0 34.6V2.4C0 1.1 1.1 0 2.5 0h54.7c1.4 0 2.5 1 2.6 2.4v32.2c-.1 1.3-1.2 2.4-2.5 2.4zM2.5 1C1.7 1 1 1.7 1 2.4v32.2c0 .8.6 1.4 1.5 1.4h54.8c.8 0 1.5-.7 1.5-1.4V2.4c-.1-.8-.7-1.4-1.6-1.4H2.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M36.1 19.5c-1.5.9-1.5 3.4-.2 4.5.9.8 2.3 1 3.5.8.9-.2 1.9-.7 2.3-1.6h.1c0 .6-.1 1.1 0 1.7h2.1c0-2.3 0-4.7.1-7.3 0-1-.3-1.9-1-2.5-.8-.7-1.9-1-3-1s-2.3.2-3.2.9c-.8.6-1.3 1.4-1.3 2.4h2c.2-.9 1-1.4 1.8-1.5.7-.1 1.7.1 2.2.8.4.5.3 1.2.3 1.8-1.9.3-4-.1-5.7 1zm5.4 2.4c-.7 1.3-2.5 1.7-3.7 1.1-.8-.3-1-1.4-.5-2 .5-.6 1.3-.7 2-.7.8 0 1.7-.1 2.4-.2 0 .6.1 1.2-.2 1.8zM26.3 20h3.2c.9 0 1.8-.2 2.6-.7 1.1-.6 1.8-1.7 2.1-2.9.3-1.3.1-2.8-.6-3.8-.5-1-1.5-1.6-2.5-1.9-1-.3-2.1-.2-3.2-.2-1.3 0-2.6-.1-3.8 0V25h2.2v-5zm.1-7.7h2.7c.8 0 1.7.2 2.2.9.6.7.8 1.6.7 2.5 0 .7-.3 1.4-.9 1.8-.6.4-1.3.6-2 .6h-2.7v-5.8zm21.3 14.6c-.5.4-1.2.3-1.8.3v1.7c1.1 0 2.3.1 3.2-.5.9-.6 1.4-1.7 1.8-2.7.9-2.6 1.8-5.3 2.8-7.9.4-1.2.9-2.3 1.2-3.3h-2.3c-.8 2.9-1.7 5.7-2.6 8.6-.9-2.9-1.8-5.7-2.7-8.6h-2.4c1.3 3.5 2.5 7 3.8 10.5-.2.7-.4 1.5-1 1.9zM16.6 9.3c-1.8 0-3.3 1.8-3.2 3.6 1.9.1 3.3-1.8 3.2-3.6zM9 23.4c.4.6.9 1.2 1.6 1.5.6.2 1.2 0 1.8-.2.6-.3 1.3-.4 1.9-.3.7.1 1.4.7 2.2.6.7-.1 1.4-.6 1.8-1.2.7-.8 1.2-1.8 1.6-2.8v-.1c-1.2-.5-2.1-1.7-2.1-3-.1-1.3.6-2.6 1.7-3.2-.9-1.3-2.5-1.9-4-1.5-.7.1-1.3.5-2 .6-.7-.2-1.4-.6-2.2-.7-1.4-.1-2.8.7-3.5 1.9-.7 1-.8 2.4-.7 3.6.2 1.8.9 3.4 1.9 4.8z"}})])
          )
        }
      }
    